// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"3b53517f","818":"3b53517f","2304":"3b53517f","4975":"3b53517f"}[chunkId] + ".chunk.css";
};